import React from "react";
import {connect} from "react-redux";
import {refreshCounters} from '../../../../../store/actions/commands/actions';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle, faClock, faSpinner, faTimesCircle} from "@fortawesome/free-solid-svg-icons";
import AnimatedNumber from "animated-number-react";
import {Tooltip} from '@material-ui/core';
import API from './../../../../../api/api';
import {USER_COMMANDS_COUNTER_URL} from './../../../../../api/_routes';

class CommandsBadges extends React.Component {
    intervalID = 0;

    componentDidMount() {
        this.intervalID = setInterval(() => {
            API.get(
                USER_COMMANDS_COUNTER_URL,
                {headers: {'Authorization': 'Bearer ' + localStorage.getItem('__token')}}
            ).then(response => {
                this.props.refreshCounters(response.data);
            }).catch(error => {

            });
        }, 60000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalID);
    }

    formatValue = (value) => value.toFixed(0);

    render() {
        return (
            <div className="nav nav-dark order-1 order-md-2">
                <Tooltip title="Pending commands" arrow>
                    <button className="btn btn-sm btn-light-primary mr-5 waves-effect waves-light">
                        <AnimatedNumber value={this.props.pendingCounter} formatValue={this.formatValue}/>
                        {' '}
                        <FontAwesomeIcon icon={faClock}/>
                        <span className="pulse-ring"></span>
                    </button>
                </Tooltip>

                <Tooltip title="Active commands" arrow>
                    <button className="btn btn-sm btn-light-warning mr-5 waves-effect waves-light">
                        <AnimatedNumber value={this.props.activeCounter} formatValue={this.formatValue}/>
                        {' '}
                        <FontAwesomeIcon icon={faSpinner} spin/>
                        <span className="pulse-ring"></span>
                    </button>
                </Tooltip>

                <Tooltip title="Failed commands" arrow>
                    <button className="btn btn-sm btn-light-danger mr-5 waves-effect waves-light">
                        <AnimatedNumber value={this.props.failedCounter} formatValue={this.formatValue}/>
                        {' '}
                        <FontAwesomeIcon icon={faTimesCircle}/>
                        <span className="pulse-ring"></span>
                    </button>
                </Tooltip>

                <Tooltip title="Completed tickets" arrow>
                    <button className="btn btn-sm btn-light-success waves-effect waves-light">
                        <AnimatedNumber value={this.props.completedCounter} formatValue={this.formatValue}/>
                        {' '}
                        <FontAwesomeIcon icon={faCheckCircle}/>
                        <span className="pulse-ring"></span>
                    </button>
                </Tooltip>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        pendingCounter: state.commands.pendingCounter,
        activeCounter: state.commands.activeCounter,
        failedCounter: state.commands.failedCounter,
        completedCounter: state.commands.completedCounter,
    }
}

export default connect(mapStateToProps, {refreshCounters})(CommandsBadges);
